import { get, post } from "../lib/fetchUtil";
import config from "./config";

const { dictionaryUrl } = config;

export async function validationMessages(): Promise<Record<string, string>> {
  const response = await get(`genericdata/validationMessages`);

  return response.json();
}

export async function enums() {
  const response = await get(`genericdata/enums`);

  return response.json();
}

export async function getAddress(postcode: string, houseNumber: number) {
  const response = await post(`genericdata/postcode?postcode=${postcode}&houseNumber=${houseNumber}`, {
    postcode,
    houseNumber,
  });

  return response.json();
}

interface FetchDictionaryResponse {
  lang: string;
  app: string;
  phrases: Record<string, string>;
}

export async function fetchDictionary(): Promise<FetchDictionaryResponse> {
  const response = await fetch(dictionaryUrl, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  return response.json();
}
